import { createSvg } from '@r1-frontend/ui-react/components/svg/createSvg';

const LampCharge = (
    {
        strokeWidth = 1.5,
    },
): JSX.Element => {
    return (
        <>
            <g id={'guts'}>
                <path
                    d='M12.0001 7.89014L10.9301 9.75014C10.6901 10.1601 10.8901 10.5001 11.3601 10.5001H12.6301C13.1101 10.5001 13.3001 10.8401 13.0601 11.2501L12.0001 13.1101'
                    strokeWidth={strokeWidth}
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
                <path
                    d='M8.30011 18.0402V16.8802C6.00011 15.4902 4.11011 12.7802 4.11011 9.90018C4.11011 4.95018 8.66011 1.07018 13.8001 2.19018C16.0601 2.69018 18.0401 4.19018
                    19.0701 6.26018C21.1601 10.4602 18.9601 14.9202 15.7301 16.8702V18.0302C15.7301 18.3202 15.8401 18.9902 14.7701 18.9902H9.26011C8.16011 19.0002 8.30011
                    18.5702 8.30011 18.0402Z'
                    strokeWidth={strokeWidth}
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
                <path
                    d='M8.5 22.0002C10.79 21.3502 13.21 21.3502 15.5 22.0002'
                    strokeWidth={strokeWidth}
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
            </g>
        </>
    );
};

export default createSvg(
    LampCharge,
    'lamp-charge',
);
